export default {
  archive({
    rootGetters, dispatch,
  }, id) {
    rootGetters['pages/getRepository'].archive(id)
      .then(() => {
        dispatch('pages/table/fetch', null, { root: true });
      });
  },
  unarchive({
    rootGetters, dispatch,
  }, id) {
    rootGetters['pages/getRepository'].unarchive(id)
      .then(() => {
        dispatch('pages/table/fetch', null, { root: true });
      });
  },
};
